// React
import { connect } from 'react-redux'
// External libs
import { get } from 'lodash'
// Components
import OrderDetailWhim from './OrderDetailWhim'
// Actions
import { injectIntl } from 'react-intl'
import dialogsManagerActions from '../../redux/actions/dialogsManager.actions'

const mapStateToProps = (
  { ordersReducer: { orders }, orderDetailDialogReducer: { orderId } },
  { intl: { formatMessage } },
) => {
  const deleteComment = formatMessage({
    id: 'orderDetailWhim.deleteButtonText',
  })
  const title = formatMessage({
    id: 'orderDetailWhim.title',
  })
  const order = orders.find(order => order.id === +orderId) || {
    id: 0,
    detail: { id: 0, products: [], user: {}, whims: [] },
  }
  const showDeleteWhim = get(order, 'beingManaged', false)

  return { deleteComment, orderId, showDeleteWhim, title }
}
const mapDispatchToProps = {
  openDeleteDialogOrderWhim: dialogsManagerActions.openDeleteOrderWhimDialog,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(OrderDetailWhim),
)
